<template>
  <div class="mt-4 p-2">
    <h3 class="section-title my-2">{{$t('tour_info_pre_reservation')}}</h3>
    <dl class="grid grid-cols-5 gap-y-2">
      <dt class="col-span-2 text-supplement font-semibold">{{$t('tour_reservation_number')}}</dt>
      <dd class="col-span-3">{{ reservation.reservationCode }}</dd>
      <dt class="col-span-2 text-supplement font-semibold">
        {{$t('tour_reservation_pickuptime')}}
      </dt>
      <dd class="col-span-3">
        <span>{{ reservation.latestEstimatePickUpTime | datetimeFormat }}</span>
      </dd>
      <dt class="col-span-2 text-supplement font-semibold">
        {{$t('tour_reservation_dropofftime')}}
      </dt>
      <dd class="col-span-3">
        <span>{{ reservation.latestEstimateDropOffTime | datetimeFormat }}</span>
      </dd>
      <dt class="col-span-2 text-supplement font-semibold">{{$t('tour_departure_label')}}：</dt>
      <dd class="col-span-3" v-html=departure></dd>
      <dt class="col-span-2 text-supplement font-semibold">{{$t('tour_arrival_label')}}：</dt>
      <dd class="col-span-3" v-html=arrival></dd>
      <dt class="col-span-2 text-supplement font-semibold">{{$t('tour_passengers')}}</dt>
      <dd class="col-span-3 ">
        <reservation-amount :seatCountDetail="reservation.seatCountDetail" :totalOnly=true />
      </dd>
      <template v-if="reservation.fare.total && reservation.fare.table">
        <dt class="col-span-2 row-span-2 text-supplement font-semibold">{{$t('tour_fee')}}</dt>
        <dd class="col-span-3">{{ reservation.fare.total }}{{$t('tour_yen')}}
          <p v-if="isMaebashi()"
            class="inline-block mt-1 py-1 px-2 border rounded text-sm leading-none border-pass text-pass">
            {{$t('tour_maebashi_fare')}}
          </p>
          <br />
          <reservation-fares :fareTable="reservation.fare.table" /></dd>
      </template>
    </dl>
    <div class="text-center bg-gray-200 p-2 my-4">
      <p class="px-12">{{$t('tour_message_auto_cancel')}}</p>
      <p class="pt-2">{{$t('tour_left')}}<span class="px-2 text-red">{{ count }}</span>{{$t('tour_second')}}</p>
    </div>
    <a @click="handleApprove" class="button-primary block mb-2" :class="{disabled: isDisabled}">{{$t('tour_reserve')}}</a>
    <a @click="handleDecline" class="button-secondary block">{{$t('tour_cancel_label')}}</a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ReservationAmount from '../../atoms/ReservationAmount'
import ReservationFares from '../../atoms/ReservationFares'
import Constants from '../../../constants'

export default {
  components: {
    ReservationAmount,
    ReservationFares
  },
  data () {
    return {
      count: 50,
      isDisabled: false
    }
  },
  created: function() {
    const timer = setInterval(() => {
      if (this.count > 0) {
        this.count = this.count - 1
      } else {
        clearInterval(timer)
        this.isDisabled = true
      }
    }, 1000)
  },
  computed: {
    ...mapGetters({
      reservation: 'reservation/getReserved',
      type: 'reservation/getType'
    }),
    departure: function () {
      let s = this.reservation.pickUpBusstopName
      if (this.type == 'POSITION') {
        //const { lat, lng } = this.reservation.pickUpPosition
        // s = this.reservation.pickUpLocationName + '<br>' + lat + ', ' + lng
        s = this.reservation.pickUpLocationName
      }
      return s
    },
    arrival: function () {
      let s = this.reservation.dropOffBusstopName
      if (this.type == 'POSITION') {
        //const { lat, lng } = this.reservation.dropOffPosition
        //s = this.reservation.dropOffLocationName + '<br>' + lat + ', ' + lng
        s = this.reservation.dropOffLocationName
      }
      return s
    }
  },
  methods: {
    handleApprove: function () {
      this.$store.dispatch('reservation/approve')
    },
    handleDecline: function () {
      this.$store.dispatch('reservation/decline')
        .then(() => {
          const env_key = process.env.VUE_APP_LINK_BASE_ENV || process.env.NODE_ENV
          location.href = Constants.LINK_BASE_URL_LIST[env_key] + '/?wallet=index'
        })
    },
    isMaebashi: function() {
      return this.$store.getters['user/isMaebashi']
    }
  }
}
</script>

<style scoped>
.gap-y-2 {
  row-gap: 0.5rem;
}
</style>
